export default __webpack_public_path__ + "static/media/instagram.d159fdf9.svg";